angular.module('impactx.demandbundle').controller('DemandBundleListCtrl', ['selectedListItems',
    'DemandBundleService',
    'dataGen',
    '$errorHandler',
    '$scope',
    '$redirect',
    DemandBundleListCtrl]);

function DemandBundleListCtrl(selectedListItems, DemandBundleService, dataGen, $errorHandler, $scope, $redirect) {
    var ctrl = this;
    this.getOrderLink = function() {
        return "demandbundledetail/" + selectedListItems.getFirstSelectedId();
    };

    this.bundleAndAddToCurrentBasket = function(event, trns) {
        ctrl.getAddToBasketData().then(function(data) {
            var unbundledItems = data.data.unBundleItems;
            if(unbundledItems.length == 0) {
                $errorHandler.showErrors([{error: trns.noBundleError}]);
                return;
            }
            if(data.data.anyAccountings || data.data.hasMaterialGroupMappings || data.data.hasHeaderComments || data.data.hasItemComments || data.data.hasOGDInfo || data.data.hasSPOInfo) {
                DemandBundleService.showAddToBasketDialog(event, unbundledItems, data.data.anyAccountings,
                    true, true, false, data.data.hasItemComments, data.data.hasMaterialGroupMappings, data.data.hasHeaderComments, data.data.hasOGDInfo, data.data.hasSPOInfo);
            }
            else {
                DemandBundleService.bundleAndAddToBasketRequest(unbundledItems, 0, false, true, false, false, false,
                   false, 0, 0);
            }
        });
    };

    this.bundleAndAddToSelectionBasket = function(event, trns) {
        ctrl.getAddToBasketData().then(function(data) {
            var unbundledItems = data.data.unBundleItems;
            if(unbundledItems.length == 0) {
                $errorHandler.showErrors([{error: trns.noBundleError}]);
                return;
            }
            DemandBundleService.showAddToBasketDialog(event, unbundledItems, data.data.anyAccountings,
                false, true, false, data.data.hasItemComments, data.data.hasMaterialGroupMappings,
                data.data.hasHeaderComments, data.data.hasOGDInfo, data.data.hasSPOInfo);

        });
    };

    this.getAddToBasketData = function() {
        return dataGen.postAsForm({}, {
            dehIds: selectedListItems.getSelectedIds()
        }, "/demandbundle/unbundleditems");
    };

    this.denyHeader = function() {
        DemandBundleService.denyHeader(selectedListItems.getFirstSelectedId(), true, false);
    };


    var buttonDefinition = [
        {
            label: "details",
            linkFunction: ctrl.getOrderLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'BundlePositions'
        },
        {
            label: "bundleAndAddToSelectionBasket",
            action: ctrl.bundleAndAddToSelectionBasket,
            condition: selectedListItems.isSingleSelection,
            process: 'BundlePositions'
        },
        {
            label: "bundleAndAddToCurrentBasket",
            action: ctrl.bundleAndAddToCurrentBasket,
            condition: selectedListItems.isSingleSelection,
            process: 'BundlePositions'
        },
        {
            label: "deny",
            action: ctrl.denyHeader,
            condition: selectedListItems.isSingleSelection,
            process: 'BundlePositions'
        }
    ];

    this.meta = {
        rowTemplate: 'modules/demandbundle/templates/demandbundlelist.row.tmpl.html',
        filtersTemplate: 'modules/demandbundle/templates/demandbundlelist.filters.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/demandbundle/list',
        id: "demandbundlelist",
        buttonDefinition: buttonDefinition,
        excelExport: true
    };
    this.getMeta = function() {
        return this.meta;
    };

    ctrl.status = "open";
    $scope.$watch(function() {
        return ctrl.status;
    }, function(current, original) {
        if(current == "done")
            $redirect.redirectTo(null, "/demandbundledonelist");
    });
}